import { IntlDateTimeFormat, createI18n } from 'vue-i18n';

declare global {
  interface Window {
    appTranslations: object;
  }
}

export const PAGE_LANG: string = document?.documentElement?.lang || 'en';
export const I18N_MESSAGES = window?.appTranslations || {};

type MessagesSchema = typeof I18N_MESSAGES;

const datetimeFormats: IntlDateTimeFormat = {
  month: {
    // January, February, March, ...
    month: 'long',
  },
  weekday: {
    // Monday, Tuesday, Wednesday, ...
    weekday: 'long',
  },
};

const i18n = createI18n<[MessagesSchema], typeof PAGE_LANG>({
  legacy: true, // Inject translation methods
  locale: PAGE_LANG,
  fallbackLocale: PAGE_LANG,
  datetimeFormats: {
    [PAGE_LANG]: datetimeFormats,
  },

  warnHtmlInMessage: import.meta.env.MODE === 'production' ? 'off' : 'error',

  missing(locale, messageKey) {
    console.error(`No '${locale}' translations found for '${messageKey}'`); // eslint-disable-line no-console
  },
  messages: {
    [PAGE_LANG]: I18N_MESSAGES,
  },
  numberFormats: {
    en: {
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 2,
      },
      percent: {
        style: 'percent',
        useGrouping: false,
      },
    },
  },
});

export const i18nSetLocale = (locale: string): void => {
  if (i18n.global.locale !== locale) {
    import('../stores/plugins/api').then((module) => {
      module.axiosInstance.defaults.headers.common.locale = locale;
    });
    // @ts-ignore -- 'locale' is a reactive, not a string. @see https://github.com/intlify/vue-i18n-next/issues/785
    i18n.global.locale.value = locale;
  }
};

i18nSetLocale(PAGE_LANG);

export default i18n;
